<app-popup [page]="'home_page'"></app-popup>
<div class="row">
  <div class="col-lg-8 col-xxl-9 mb-4">
    <app-advertisement></app-advertisement>
    <!-- <div
      class="home-sport-section bg-blue-gradient rounded-10 py-3 px-4 mb-4 text-white"
    >
      <div class="row">
        <div class="col-12 col-md-auto mb-3 text-center text-md-start">
          <a href="javascript:void(0)" routerLink="/">
            <img
              src="../assets/img/kingpin-logo-white.png"
              alt="logo"
              class="img-fluid"
              width="92"
              height="86"
            />
          </a>
        </div>
        <div
          class="col-12 col-md-9 align-self-center mb-3 text-center text-md-start"
        >
          <h1 class="fw-bolder">SPORTS BETTING PICKS</h1>
          <h2 class="mb-0">All the best sports picks in one place</h2>
        </div>
        <div class="follow-and-app-area">
          <ul class="list-inline mb-0 text-center text-lg-start">
            <li class="list-inline-item mb-3">
              <a
                *ngIf="!(_user.subscribed | async)"
                routerLink="/subscription"
                class="btn btn-subscription btn-block text-f14 py-2 px-3 fw-bolder"
                >Upgrade</a
              >
            </li>
            <li class="list-inline-item mb-3" *ngIf="platform != 'iOS'">
              <a [href]="playstore" target="_blank">
                <img
                  src="../assets/img/play-store.png"
                  alt="play-store"
                  class="img-fluid"
                  width="130"
                  height="43"
              /></a>
            </li>
            <li class="list-inline-item mb-3" *ngIf="platform != 'Android'">
              <a [href]="appstore" target="_blank">
                <img
                  src="../assets/img/apple-store.png"
                  alt="apple-store"
                  class="img-fluid"
                  width="130"
                  height="43"
              /></a>
            </li>
          </ul>
        </div>
        <div class="mb-3" *ngIf="_common.isBrowser">
          <app-subscription-features-slider></app-subscription-features-slider>
        </div>
        <div class="row">
          <div class="col-12 col-lg-6">
            <h3 class="fw-bolder mb-4">
              Stop paying overpriced individual handicappers
            </h3>
            <ul class="list-unstyled">
              <li>
                Kingpin PRO subscription allows you to:
                <ul>
                  <li>Follow ALL our handicappers in one place</li>
                  <li>Get the Sharp Pick for each game</li>
                </ul>
              </li>
              <li>We track records to make sure you follow the best bets</li>
            </ul>
          </div>
          <div class="col-12 col-lg-6">
            <h3 class="fw-bolder mb-4 mb-xxl-5">
              Handicappers: win cash for free
            </h3>
            <ul class="list-unstyled">
              <li>Win a share of our $0 monthly pot</li>
              <li>FREE to play</li>
              <li>Place your picks today</li>
              <li>Gain a track record and win free cash</li>
            </ul>
          </div>
        </div>
      </div>
    </div> -->
    <div class="row" *ngIf="_common.isBrowser">
      <app-article [limit]="9" [showFeatured]="true"></app-article>
    </div>
    <div class="row">
      <app-additional-content></app-additional-content>
    </div>
  </div>
  <div class="col-lg-4 col-xxl-3 mb-4">
    <app-top-users></app-top-users>
    <app-upcoming-general></app-upcoming-general>
  </div>
</div>
